import React, { useState } from 'react';
import api from '../services/api';
import { localDateStr } from '../utils/dateUtils';

// ── Icons ─────────────────────────────────────────────────────────────────────
const IconDatabase = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5"/><path d="M3 12c0 1.66 4.03 3 9 3s9-1.34 9-3"/></svg>;
const IconFile     = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>;
const IconClip     = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="13" y2="16"/></svg>;
const IconUsers    = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>;
const IconCal      = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IconClock    = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IconGlobe    = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/></svg>;
const IconCOA      = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><polyline points="9 12 11 14 15 10"/></svg>;
const IconReceipt  = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="12" y2="16"/><path d="M15 16l1.5-1.5L18 16"/></svg>;
const IconCompete  = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;
const IconFlask    = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><path d="M9 3h6M9 3v8l-4 9h14L15 11V3M9 3"/><line x1="6" y1="14" x2="18" y2="14"/></svg>;
const IconMap      = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg>;
const IconDownload = <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"/></svg>;
const IconTally    = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="3" width="20" height="18" rx="2"/><line x1="2" y1="9" x2="22" y2="9"/><line x1="8" y1="9" x2="8" y2="21"/><line x1="5" y1="13" x2="7" y2="13"/><line x1="5" y1="17" x2="7" y2="17"/><line x1="10" y1="13" x2="20" y2="13"/><line x1="10" y1="17" x2="16" y2="17"/></svg>;
const IconShield   = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>;
const IconMail     = <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22 6 12 13 2 6"/></svg>;

// ── Color palettes ────────────────────────────────────────────────────────────
const C = {
  blue:   { color: 'var(--primary)',  bg: 'var(--primary-lighter)' },
  green:  { color: '#059669',         bg: '#ecfdf5' },
  purple: { color: '#7c3aed',         bg: '#f5f3ff' },
  orange: { color: '#d97706',         bg: '#fffbeb' },
  red:    { color: '#dc2626',         bg: '#fef2f2' },
  teal:   { color: '#0891b2',         bg: '#ecfeff' },
};

// ── Section header ────────────────────────────────────────────────────────────
function SectionHeader({ title }) {
  return (
    <div style={{ borderBottom: '2px solid var(--border)', paddingBottom: 7, marginTop: 32, marginBottom: 14 }}>
      <span style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '1px' }}>
        {title}
      </span>
    </div>
  );
}

// ── Download helper ───────────────────────────────────────────────────────────
async function doDownload(url, id, format, params = {}) {
  const qp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v) qp.set(k, v);
  const token = localStorage.getItem('token');
  const base  = api.defaults.baseURL || '/api';
  const full  = `${base}${url}${qp.toString() ? '?' + qp : ''}`;
  const r = await fetch(full, { headers: { Authorization: `Bearer ${token}` } });
  if (!r.ok) { const t = await r.text(); throw new Error(t || `HTTP ${r.status}`); }
  const blob = await r.blob();
  const ext  = format?.includes('xlsx') ? '.xlsx' : format?.includes('XML') ? '.xml' : '.csv';
  const a    = document.createElement('a');
  a.href     = URL.createObjectURL(blob);
  a.download = `prasilabs_${id}_${localDateStr()}${ext}`;
  a.click();
  URL.revokeObjectURL(a.href);
}

// ── Simple export card ────────────────────────────────────────────────────────
function ExportCard({ item }) {
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  const handleDownload = async () => {
    setLoading(true); setError(null);
    try { await doDownload(item.url, item.id, item.format); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
      <div style={{ padding: '16px 20px', display: 'flex', gap: 14, alignItems: 'flex-start' }}>
        <div style={{ width: 40, height: 40, borderRadius: 9, flexShrink: 0, background: item.bg, color: item.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {item.icon}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3, flexWrap: 'wrap' }}>
            <span style={{ fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-primary)' }}>{item.title}</span>
            <span style={{ fontSize: '0.68rem', fontWeight: 600, padding: '1px 7px', borderRadius: 20, background: 'var(--surface-2)', color: 'var(--text-muted)' }}>{item.format}</span>
            {item.adminOnly && <span style={{ fontSize: '0.68rem', fontWeight: 600, padding: '1px 7px', borderRadius: 20, background: '#fef3c7', color: '#92400e' }}>Admin only</span>}
          </div>
          <p style={{ margin: 0, fontSize: '0.8rem', color: 'var(--text-secondary)', lineHeight: 1.5 }}>{item.desc}</p>
          {error && <div style={{ marginTop: 6, fontSize: '0.75rem', color: '#dc2626' }}>{error}</div>}
        </div>
        <button className="btn btn-primary btn-sm" style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0, alignSelf: 'center' }}
          onClick={handleDownload} disabled={loading}>
          {loading ? <span className="spinner" style={{ width: 12, height: 12, borderWidth: 2 }} /> : IconDownload}
          {loading ? 'Preparing…' : 'Download'}
        </button>
      </div>
    </div>
  );
}

// ── Filtered export card (supports date/month/select filters) ─────────────────
function FilteredExportCard({ item }) {
  const [vals,    setVals]    = useState({});
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  const handleDownload = async () => {
    setLoading(true); setError(null);
    try { await doDownload(item.url, item.id, item.format, vals); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const set = (k, v) => setVals(prev => ({ ...prev, [k]: v }));

  return (
    <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
      <div style={{ padding: '16px 20px', display: 'flex', gap: 14, alignItems: 'flex-start' }}>
        <div style={{ width: 40, height: 40, borderRadius: 9, flexShrink: 0, background: item.bg, color: item.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {item.icon}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3, flexWrap: 'wrap' }}>
            <span style={{ fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-primary)' }}>{item.title}</span>
            <span style={{ fontSize: '0.68rem', fontWeight: 600, padding: '1px 7px', borderRadius: 20, background: 'var(--surface-2)', color: 'var(--text-muted)' }}>{item.format}</span>
            {item.adminOnly && <span style={{ fontSize: '0.68rem', fontWeight: 600, padding: '1px 7px', borderRadius: 20, background: '#fef3c7', color: '#92400e' }}>Admin only</span>}
          </div>
          <p style={{ margin: '0 0 10px', fontSize: '0.8rem', color: 'var(--text-secondary)', lineHeight: 1.5 }}>{item.desc}</p>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            {item.filters.map(f => (
              <div key={f.key}>
                <label style={{ display: 'block', fontSize: '0.7rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: 3 }}>{f.label}</label>
                {f.inputType === 'select' ? (
                  <select className="form-control" style={{ fontSize: '0.82rem', padding: '5px 9px', minWidth: 130 }}
                    value={vals[f.key] || ''} onChange={e => set(f.key, e.target.value)}>
                    <option value="">All</option>
                    {f.options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                  </select>
                ) : (
                  <input type={f.inputType} className="form-control"
                    style={{ fontSize: '0.82rem', padding: '5px 9px', width: f.inputType === 'month' ? 140 : 148 }}
                    value={vals[f.key] || ''} onChange={e => set(f.key, e.target.value)} />
                )}
              </div>
            ))}
          </div>
          {error && <div style={{ marginTop: 6, fontSize: '0.75rem', color: '#dc2626' }}>{error}</div>}
        </div>
        <button className="btn btn-primary btn-sm" style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0, alignSelf: 'flex-start', marginTop: 4 }}
          onClick={handleDownload} disabled={loading}>
          {loading ? <span className="spinner" style={{ width: 12, height: 12, borderWidth: 2 }} /> : IconDownload}
          {loading ? 'Preparing…' : 'Download'}
        </button>
      </div>
    </div>
  );
}

// ── Export definitions ────────────────────────────────────────────────────────

const FULL_EXPORT = {
  id: 'all', title: 'Full Database Export',
  desc: '43-sheet Excel workbook covering every table: Clients, Contacts, Customers, Catalog, Inquiries, Quote Items, Orders, Order Items, Payments, Expenses, Projects, Milestones, Service Requests, Visits, Activities, Tasks, Territories, COA, COA Tests, Samples, Sample Issuances, Competitors, Comp Mentions, CAPAs, CAPA Actions, Email Templates, Employees (full), Salary Structure, Leaves, Pay Revisions, Payroll, Attendance, document registries, Users, User Personas, MR Targets, TVA Targets, Audit Logs, Web Inquiries, Company Settings.',
  format: 'Excel (.xlsx)', url: '/export/all', icon: IconDatabase, adminOnly: true, ...C.blue,
};

const SALES_SIMPLE = [
  { id: 'clients',     title: 'Clients Export',     desc: 'All business clients with billing/shipping addresses, GSTIN, license details, credit limits, and assignment.',         format: 'CSV (.csv)', url: '/export/clients',     icon: IconUsers, ...C.blue   },
  { id: 'customers',   title: 'Customers Export',   desc: 'All individual customers/doctors with specialty, territory, license expiry, and credit limit.',                        format: 'CSV (.csv)', url: '/export/customers',   icon: IconUsers, ...C.green  },
  { id: 'contacts',    title: 'Contacts Export',    desc: 'All client contacts with designation, department, email, and phone.',                                                  format: 'CSV (.csv)', url: '/export/contacts',    icon: IconUsers, ...C.purple },
  { id: 'inquiries',   title: 'Inquiries Export',   desc: 'All sales inquiries and quotes with client, product, currency, subtotal, discount, amount, and status.',               format: 'CSV (.csv)', url: '/export/inquiries',   icon: IconClip,  ...C.blue   },
  { id: 'quote-items', title: 'Quote Items Export', desc: 'Line items for every inquiry/quote — catalog number, unit price, quantity, discount, and line total.',                 format: 'CSV (.csv)', url: '/export/quote-items', icon: IconClip,  ...C.teal   },
  { id: 'activities',  title: 'Activities Export',  desc: 'CRM activity log — calls, meetings, emails, demos — with status, priority, client, and outcome.',                      format: 'CSV (.csv)', url: '/export/activities',  icon: IconCal,   ...C.orange },
  { id: 'territories', title: 'Territories Export', desc: 'Sales territories with state coverage, manager assignment, and active status.',                                          format: 'CSV (.csv)', url: '/export/territories', icon: IconMap,   ...C.teal   },
  { id: 'tasks',       title: 'Tasks Export',       desc: 'All tasks with priority, status, assigned user, due date, and linked entity. Sorted by status then priority.',           format: 'XLSX (.xlsx)', url: '/export/tasks',      icon: IconClip,  ...C.purple },
];
const SALES_FILTERED = [
  { id: 'visits', title: 'Visits Export', desc: 'Field visits with DCR data (purpose, products discussed, samples given, doctor feedback). Optionally filter by date range.',
    format: 'CSV (.csv)', url: '/export/visits', icon: IconClock, ...C.teal,
    filters: [
      { key: 'from_date', label: 'From Date', inputType: 'date' },
      { key: 'to_date',   label: 'To Date',   inputType: 'date' },
    ],
  },
];

const FINANCE_SIMPLE = [
  { id: 'orders',      title: 'Orders Export',      desc: 'All orders (invoices, POs, proformas) with client name, totals, tax, waybill, dispatch info, and status.',  format: 'CSV (.csv)', url: '/export/orders',      icon: IconFile,    ...C.blue   },
  { id: 'order-items', title: 'Order Items Export', desc: 'Line items per order — catalog number, HSN code, pack size, quantity, unit price, discount, and line total.', format: 'CSV (.csv)', url: '/export/order-items', icon: IconFile,    ...C.purple },
  { id: 'payments',    title: 'Payments Export',    desc: 'All payments received with order reference, client name, payment method, and date.',                          format: 'CSV (.csv)', url: '/export/payments',    icon: IconReceipt, ...C.green  },
  { id: 'tally-vouchers', title: 'Tally Vouchers (XML)', desc: 'Sales invoices and receipts in Tally Prime XML import format. Import directly into Tally Prime via Gateway of Tally → Import → Data.', format: 'XML', url: '/export/tally-vouchers', icon: IconTally, ...C.green },
];
const FINANCE_FILTERED = [
  { id: 'expenses', title: 'Expenses Export', desc: 'Company expenses by category with vendor, reference, and amount. Optionally filter by date range.',
    format: 'CSV (.csv)', url: '/export/expenses', icon: IconReceipt, ...C.orange,
    filters: [
      { key: 'from_date', label: 'From Date', inputType: 'date' },
      { key: 'to_date',   label: 'To Date',   inputType: 'date' },
    ],
  },
  { id: 'gstr1', title: 'GSTR-1 Export', desc: 'Invoice data in GSTR-1 format for GST filing — recipient GSTIN, place of supply, taxable value, CGST/SGST/IGST breakdown.',
    format: 'CSV (.csv)', url: '/export/gstr1', icon: IconReceipt, ...C.green,
    filters: [
      { key: 'from', label: 'From Date', inputType: 'date' },
      { key: 'to',   label: 'To Date',   inputType: 'date' },
    ],
  },
];

const PRODUCTS_SIMPLE = [
  { id: 'catalog',           title: 'Catalog Export',           desc: 'Full product catalog with HSN codes, MRP, cost price, stock quantity, and low-stock alert thresholds.',    format: 'CSV (.csv)', url: '/export/catalog',           icon: IconDatabase, ...C.blue   },
  { id: 'coa',               title: 'COA Export',               desc: 'Certificate of Analysis records with product details, analysis dates, retest dates, and approval status.',   format: 'CSV (.csv)', url: '/export/coa',               icon: IconCOA,      ...C.green  },
  { id: 'samples',           title: 'Sample Inventory Export',  desc: 'Sample batches with product, catalog number, total and distributed quantities per batch.',                    format: 'CSV (.csv)', url: '/export/samples',           icon: IconFlask,    ...C.orange },
  { id: 'sample-issuances',  title: 'Sample Issuances Export',  desc: 'Full distribution log — who was given which sample, when, in what quantity, and acknowledgement status.',    format: 'CSV (.csv)', url: '/export/sample-issuances',  icon: IconFlask,    ...C.teal   },
];

const PROJECTS_SIMPLE = [
  { id: 'projects',         title: 'Projects Export',         desc: 'All R&D and synthesis projects with status, timeline, budget, client, and assignment.',              format: 'CSV (.csv)', url: '/export/projects',         icon: IconFile,    ...C.blue   },
  { id: 'service-requests', title: 'Service Requests Export', desc: 'All service requests with type, priority, status, assigned employee, and resolution notes.',         format: 'CSV (.csv)', url: '/export/service-requests', icon: IconClip,    ...C.purple },
  { id: 'competitors',      title: 'Competitor Intelligence', desc: 'Competitive encounters — competitor name, customer, context, outcome (won/lost/neutral), and notes.', format: 'CSV (.csv)', url: '/export/competitors',      icon: IconCompete, ...C.red    },
];

const HR_SIMPLE = [
  { id: 'employees',        title: 'Employees Export',         desc: 'Full employee records — personal info, bank details, PAN, Aadhaar, emergency contacts, reporting structure.',   format: 'CSV (.csv)', url: '/export/employees',        icon: IconUsers,   ...C.blue   },
  { id: 'salary-structure', title: 'Salary Structure Export',  desc: 'Per-employee salary breakdown: Basic, HRA, DA, TA, Special Allowance, PF%, PT, TDS (current structure).',       format: 'CSV (.csv)', url: '/export/salary-structure',  icon: IconReceipt, ...C.green  },
  { id: 'employee-leaves',  title: 'Employee Leaves Export',   desc: 'All leave requests with type, dates, total days, status, and approver.',                                          format: 'CSV (.csv)', url: '/export/employee-leaves',   icon: IconCal,     ...C.orange },
  { id: 'pay-revisions',   title: 'Pay Revisions Export',     desc: 'Employee salary revision history — old vs new salary, revision type, effective date, and percentage change.',     format: 'CSV (.csv)', url: '/export/pay-revisions',     icon: IconReceipt, ...C.purple },
];
const HR_FILTERED = [
  { id: 'attendance', title: 'Attendance Export', desc: 'Daily check-in/check-out records with working hours and attendance status. Optionally filter by date range.',
    format: 'CSV (.csv)', url: '/export/attendance', icon: IconClock, ...C.green,
    filters: [
      { key: 'from_date', label: 'From Date', inputType: 'date' },
      { key: 'to_date',   label: 'To Date',   inputType: 'date' },
    ],
  },
  { id: 'payroll', title: 'Payroll Export', desc: 'Monthly payroll with full earnings breakdown (Basic, HRA, DA, TA, Special), PF, TDS, PT deductions, and net pay. Optionally filter by month range.',
    format: 'CSV (.csv)', url: '/export/payroll', icon: IconReceipt, ...C.purple,
    filters: [
      { key: 'from_month', label: 'From Month', inputType: 'month' },
      { key: 'to_month',   label: 'To Month',   inputType: 'month' },
    ],
  },
];

const TARGETS_SIMPLE = [
  { id: 'mr-targets',  title: 'MR Targets Export',  desc: 'MR monthly targets — revenue, inquiry count, order count per user per month.',              format: 'CSV (.csv)', url: '/export/mr-targets',  icon: IconMap, ...C.blue   },
  { id: 'tva-targets', title: 'TVA Targets Export',  desc: 'Territory visit activity targets — revenue, visit count, and new customer targets per user.', format: 'CSV (.csv)', url: '/export/tva-targets', icon: IconMap, ...C.orange },
];

const QUALITY_SIMPLE = [
  { id: 'capas',        title: 'CAPAs Export',        desc: 'Corrective & Preventive Actions — type, source, severity, status, root cause, immediate action, and closure details.', format: 'CSV (.csv)', url: '/export/capas',        icon: IconShield, ...C.red    },
  { id: 'capa-actions', title: 'CAPA Actions Export',  desc: 'Action items per CAPA — description, assignee, due date, and completion status.',                                      format: 'CSV (.csv)', url: '/export/capa-actions', icon: IconShield, ...C.orange },
];

const SYSTEM_SIMPLE = [
  { id: 'web-inquiries',    title: 'Web Inquiries Export',    desc: 'Public website contact form submissions with company, email, product interest, and resolution status.', format: 'CSV (.csv)', url: '/export/web-inquiries',    icon: IconGlobe,    ...C.blue   },
  { id: 'email-templates',  title: 'Email Templates Export',  desc: 'Email template library — name, subject, category, HTML body, and active status.',                      format: 'CSV (.csv)', url: '/export/email-templates',  icon: IconMail,     ...C.teal   },
  { id: 'user-personas',    title: 'User Personas Export',    desc: 'Role persona definitions with department, territory, and allowed page permissions.',                    format: 'CSV (.csv)', url: '/export/user-personas',    icon: IconUsers,    ...C.purple },
  { id: 'company-settings', title: 'Company Settings Export', desc: 'CRM company configuration and settings as stored in the database (JSON).',          adminOnly: true,   format: 'CSV (.csv)', url: '/export/company-settings', icon: IconDatabase, ...C.red    },
];
const SYSTEM_FILTERED = [
  { id: 'audit-logs', title: 'Audit Logs Export', desc: 'System audit trail of all user actions with timestamps, IP addresses, and entity details. Filter by date, entity type, or action. Exports as Excel.',
    format: 'Excel (.xlsx)', url: '/export/audit-logs', icon: IconDatabase, adminOnly: true, ...C.red,
    filters: [
      { key: 'from_date', label: 'From Date', inputType: 'date' },
      { key: 'to_date',   label: 'To Date',   inputType: 'date' },
      { key: 'entity',    label: 'Entity Type', inputType: 'select', options: [
        { value: 'client',    label: 'Client'    },
        { value: 'customer',  label: 'Customer'  },
        { value: 'order',     label: 'Order'     },
        { value: 'inquiry',   label: 'Inquiry'   },
        { value: 'project',   label: 'Project'   },
        { value: 'catalog',   label: 'Catalog'   },
        { value: 'employee',  label: 'Employee'  },
        { value: 'user',      label: 'User'      },
      ]},
      { key: 'action', label: 'Action', inputType: 'select', options: [
        { value: 'CREATE', label: 'Create' },
        { value: 'UPDATE', label: 'Update' },
        { value: 'DELETE', label: 'Delete' },
        { value: 'LOGIN',  label: 'Login'  },
        { value: 'LOGOUT', label: 'Logout' },
        { value: 'FREEZE', label: 'Freeze' },
      ]},
    ],
  },
];

// ── Full-export sheet directory ───────────────────────────────────────────────
const SHEETS = [
  ['Orders',           'All order types — totals, tax, waybill, dispatch info'],
  ['Order Items',      'Line items per order — join on order_number'],
  ['Clients',          'Business clients — GSTIN, billing/shipping addresses, credit'],
  ['Contacts',         'Client contacts with roles and departments'],
  ['Customers',        'Individual customers — license, territory, credit'],
  ['Catalog',          'Products with HSN codes, cost price, stock levels'],
  ['Inquiries',        'Sales inquiries and quotes with discount/subtotal'],
  ['Quote Items',      'Line items per inquiry/quote — join on inquiry_number'],
  ['Web Inquiries',    'Public website contact form submissions'],
  ['Projects',         'R&D and synthesis projects with budget and milestones'],
  ['Service Requests', 'SR tracking with priority, status, employee assignment'],
  ['Visits',           'Field visits with full DCR data'],
  ['Payments',         'Payments received — linked via order_number'],
  ['Expenses',         'Company expenses by category with vendor info'],
  ['COA',              'Certificate of Analysis records'],
  ['COA Tests',        'Test results per COA — join on coa_number'],
  ['Employees',        'Full HR records — bank, PAN, Aadhaar, emergency contacts'],
  ['Salary Structure', 'Salary components per employee (Basic, HRA, DA, PF%...)'],
  ['Leaves',           'Employee leave requests and approvals'],
  ['Pay Revisions',    'Employee salary revision history'],
  ['Payroll',          'Monthly payroll with earnings and deductions'],
  ['Attendance',       'Daily check-in/check-out records'],
  ['Emp Documents',    'Employee document registry (metadata only)'],
  ['Client Documents', 'Client document registry (metadata only)'],
  ['Customer Docs',    'Customer document registry (metadata only)'],
  ['Order Documents',  'Order document registry (metadata only)'],
  ['Users',            'CRM system users with roles'],
  ['User Personas',    'Role persona definitions with allowed pages'],
  ['MR Targets',       'MR monthly revenue/inquiry/order targets'],
  ['TVA Targets',      'Territory visit activity targets per user/month'],
  ['Audit Logs',       'Last 5,000 system audit events'],
  ['Territories',      'Sales territories with state coverage and manager'],
  ['Activities',       'CRM activities — calls, meetings, emails, demos'],
  ['Competitors',      'Competitor master list with strengths/weaknesses'],
  ['Comp Mentions',    'Competitive encounters per customer'],
  ['Samples',          'Sample inventory with distribution quantities'],
  ['Sample Issuances', 'Sample distribution log — recipient, quantity, date'],
  ['Proj Milestones',  'Project milestones — join on project_code'],
  ['Company Settings', 'CRM configuration and company settings (JSON)'],
  ['CAPAs',            'Corrective & Preventive Actions — severity, status, root cause'],
  ['CAPA Actions',     'Action items per CAPA — assignee, due date, completion status'],
  ['Email Templates',  'Email template library with subjects, HTML body, and category'],
];

// ── Main component ────────────────────────────────────────────────────────────
export default function DataExport() {
  return (
    <div style={{ maxWidth: 860, margin: '0 auto', padding: '8px 0 48px' }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: '1.35rem', fontWeight: 700, color: 'var(--text-primary)', margin: 0 }}>Data Export</h1>
        <p style={{ color: 'var(--text-secondary)', marginTop: 4, fontSize: '0.85rem' }}>
          Export CRM data to Excel or CSV. All records are cross-referenced by IDs for easy analysis.
        </p>
      </div>

      {/* ── Full export ── */}
      <ExportCard item={FULL_EXPORT} />

      {/* ── Sales & CRM ── */}
      <SectionHeader title="Sales & CRM" />
      {SALES_SIMPLE.map(i => <ExportCard key={i.id} item={i} />)}
      {SALES_FILTERED.map(i => <FilteredExportCard key={i.id} item={i} />)}

      {/* ── Finance ── */}
      <SectionHeader title="Finance" />
      {FINANCE_SIMPLE.map(i => <ExportCard key={i.id} item={i} />)}
      {FINANCE_FILTERED.map(i => <FilteredExportCard key={i.id} item={i} />)}

      {/* ── Products & Quality ── */}
      <SectionHeader title="Products & Quality" />
      {PRODUCTS_SIMPLE.map(i => <ExportCard key={i.id} item={i} />)}

      {/* ── Projects & Operations ── */}
      <SectionHeader title="Projects & Operations" />
      {PROJECTS_SIMPLE.map(i => <ExportCard key={i.id} item={i} />)}

      {/* ── Quality & Compliance ── */}
      <SectionHeader title="Quality & Compliance" />
      {QUALITY_SIMPLE.map(i => <ExportCard key={i.id} item={i} />)}

      {/* ── Human Resources ── */}
      <SectionHeader title="Human Resources" />
      {HR_SIMPLE.map(i => <ExportCard key={i.id} item={i} />)}
      {HR_FILTERED.map(i => <FilteredExportCard key={i.id} item={i} />)}

      {/* ── Targets ── */}
      <SectionHeader title="Targets & KPIs" />
      {TARGETS_SIMPLE.map(i => <ExportCard key={i.id} item={i} />)}

      {/* ── System & Compliance ── */}
      <SectionHeader title="System & Compliance" />
      {SYSTEM_SIMPLE.map(i => <ExportCard key={i.id} item={i} />)}
      {SYSTEM_FILTERED.map(i => <FilteredExportCard key={i.id} item={i} />)}

      {/* ── Full export sheet directory ── */}
      <div className="card" style={{ marginTop: 32, padding: '16px 20px' }}>
        <h3 style={{ margin: '0 0 12px', fontSize: '0.875rem', fontWeight: 700, color: 'var(--text-primary)' }}>
          Full Export — Sheet Directory ({SHEETS.length} data sheets + INDEX)
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px 24px' }}>
          {SHEETS.map(([sheet, desc]) => (
            <div key={sheet} style={{ display: 'flex', gap: 8, alignItems: 'baseline', fontSize: '0.78rem' }}>
              <span style={{ fontWeight: 600, color: 'var(--primary)', minWidth: 112, flexShrink: 0 }}>{sheet}</span>
              <span style={{ color: 'var(--text-secondary)' }}>{desc}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
